// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__dX-L7"};